//src/services/payments.js
import API from "./api";


// ===============================
// 🟡 PAYSTACK (KEEP - DO NOT BREAK)
// ===============================

export const initiatePayment = async (data) => {

    //request backend to generate Paystack transaction
    const res = await API.post("/payments/initiate", null, {
       params: data,
    });
    return res.data; // contain paystack transaction details
};

export const verifyPayment  = async (reference) => {

    // request backend to verify Paystack transaction
    const res = await API.get("/payments/verify", {
        params: { reference },
    });
    return res.data
};

// ===============================
// 🔵 FLUTTERWAVE (NEW - ACTIVE)
// ===============================

export const initiateFlutterwavePayment = async (data) => {
    const res = await API.post("/payments/initiate/flutterwave", null, {
      params: data,
    });
    return res.data;
  };
  
  export const verifyFlutterwavePayment = async (transaction_id) => {
    const res = await API.get("/payments/verify/flutterwave", {
      params: { transaction_id },
    });
    return res.data;
  };